<template>
  <transition name="fade">
    <div v-if="toastPopupVisible">
      <b-card no-body style="margin-top: 5px; border: 2px solid #224a66;">
        <b-card-header style="padding: 0.5rem 0.5em">
          <b-row>
            <b-col>
              <h6 class="mb-0" style="color: darkred; font-weight: bold">{{ popupNotification.headline }}</h6>
            </b-col>
            <b-col>
              <b-button-close
                  @click="closePopupToastWindow()"
              >
              </b-button-close>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body style="padding: 0.7rem;">
          <b-card-text>
            <b-link @click.stop="showDetailsNotification(popupNotification.id)" v-if="!popupNotification.isLocal">
              <p>{{ popupNotification.headline }}</p>
            </b-link>
            <div v-if="popupNotification.isLocal && popupNotification.body" v-html="popupNotification.body"></div>
          </b-card-text>
        </b-card-body>
      </b-card>

    </div>
  </transition>
</template>

<script>

import ActivityManager from "@/activity/ActivityManager";
import NotificationDetails from "@/components/notifications/NotificationDetails";
import UserNotification from "@/server/com/silkplm/model/users/UserNotification"
import {
  LocalNotification,
  registerPopupComponent,
  showLocalNotification
} from "@/components/notifications/LocalNotification";
import Events from "@/utils/Events";

export default {
  name: "BellNotification",
  components: {},

  async beforeMount() {
  },

  async mounted() {
    this.timer = null;
    registerPopupComponent(this);
    this.$onEvent(ServerEvents.newNotification, notification => {
      if (notification.popupTitle && notification.popupBody) {
        showLocalNotification(new LocalNotification(notification.popupTitle, notification.popupBody));
      } else {
        this.$onEvent(ServerEvents.newNotification, this.onNewNotification);
      }
    });

  },

  methods: {

    async showLocalNotification(notificationData) {

      if (this.toastPopupVisible === true) {
        if (notificationData.force) {
          await this.hidePopupToast(true, true);
          this.popupNotification = notificationData;
          await this.showPopupToast();
        } else {
          this.queueOfPopupNotifications.push(notificationData);
        }
        return;
      }
      this.popupNotification = notificationData;
      await this.showPopupToast();
    },
    async showDetailsNotification(id) {
      await ActivityManager.showActivity(NotificationDetails, {notificationId: id});
    },

    async onNewNotification() {
      await this.loadNotifications();
      if (this.listOfTheLatestNotifications?.[0]?.autoPopup === true) {
        if (this.toastPopupVisible === true)
          this.queueOfPopupNotifications.push(this.listOfTheLatestNotifications[0]);
        else {
          this.popupNotification = this.listOfTheLatestNotifications[0];
          await this.showPopupToast();
        }
      }
    },

    async checkQueueOfPopupNotifications() {
      if (this.queueOfPopupNotifications.length) {
        this.popupNotification = this.queueOfPopupNotifications[0];
        this.queueOfPopupNotifications.shift();
        await this.showPopupToast();
      }
    },


    waitForAnimations(fast = false) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, fast ? 600 : 5000);
      });
    },

    async hidePopupToast(fast = false, skipCheck = false) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.toastPopupVisible = false;
      await this.waitForAnimations(fast);
      if (!skipCheck) {
        await this.checkQueueOfPopupNotifications();
      }
    },

    async showPopupToast() {
      this.toastPopupVisible = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(await this.hidePopupToast, this.popupNotification.hideAfter ?? 5000);

      await this.waitForAnimations();
    },

    async closePopupToastWindow() {
      this.toastPopupVisible = false;
      await this.waitForAnimations();
      if (!this.popupNotification.isLocal && this.listOfTheLatestNotifications.length)
        await Rpc.Notifications.markAsRead(this.popupNotification.id);
      await this.checkQueueOfPopupNotifications();
    },

    async loadNotifications() {
      this.listOfTheLatestNotifications = await Rpc.Notifications.getLastUnseen(this.numberOfNotificationsOnBell);
    },

  },

  data: () => ({
    listOfTheLatestNotifications: [],
    numberOfNotificationsOnBell: 5,
    toastPopupVisible: false,
    queueOfPopupNotifications: [],
    popupNotification: new UserNotification(),
  }),

}
</script>

